<template>
  <div class="detail-view">
    <div class="tag-top-detail"></div>
    <div class="title-box">
      <p class="view-title-clip">
        {{ contentInfo.channelname }} <span v-html="contentInfo.title"></span>
      </p>
    </div>
    <div class="desc-info-box">
      <span class="desc-info">
        {{ contentInfo.starttime }} ~ {{ contentInfo.endtime }}
      </span>
    </div>
    <div class="optional-buttons">
      <icon-box-zzim-with-api
        section="live"
        :content-id="contentId"
        :zzim="zzim"
      ></icon-box-zzim-with-api>
      <icon-box-sns-share :content-info="contentInfo"></icon-box-sns-share>
      <icon-box-schedule :content-info="contentInfo"></icon-box-schedule>
      <a
        v-if="isVisibleVodButton"
        href="#"
        class="icon-box"
        @click.prevent="moveToVod()"
      >
        <IconMainVod />
        <span class="icon-txt">VOD 보기</span>
      </a>
    </div>
    <player-action-button
      :content-info="contentInfo"
      section="live"
    ></player-action-button>
    <div class="next-lineup">
      <div class="next">다음방송</div>
      <div class="program-metadata">
        <span class="program-title" v-html="nextLineupTitle"></span>
        <span class="program-play-time" v-html="nextLineUpPlayTime"></span>
      </div>
      <alarm-button
        v-if="!isPooqzone"
        :content-info="contentInfo"
      ></alarm-button>
    </div>
  </div>
</template>
<script>
  import { topTagList } from '@/common/directives'
  import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
  import IconBoxSchedule from '@/components/play/IconBoxSchedule'
  import IconMainVod from '@/assets/svg/common/icon-main-vod.svg'
  import AlarmButton from '@/components/play/AlarmButton'
  // import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
  import { get } from 'lodash'
  import utils from '@/common/util/utils'
  import PlayerActionButton from '@/components/play/PlayerActionButtonForLive'
  import { LiveInfoService } from '@/common/api/api.service'
  import IconBoxZzimWithApi from '@/components/play/IconBoxZzimWithApi'
  import { PATH_NAME_PLAYER } from '@/common/router.const'

  export default {
    name: 'LivePlayerDetailInfo',
    components: {
      IconBoxZzimWithApi,
      AlarmButton,
      IconBoxSchedule,
      IconBoxSnsShare,
      IconMainVod,
      PlayerActionButton,
    },
    directives: {
      topTagList,
    },
    props: {
      contentInfo: {
        type: Object,
      },
    },
    data() {
      return {
        isPooqzone: utils.cookies.isPooqZone(),
        isVisibleVodButton: false,
      }
    },
    computed: {
      nextLineupTitle() {
        return get(
          this.contentInfo,
          ['liveepgschannellist', 'list', '0', 'title'],
          '',
        )
      },
      nextLineUpPlayTime() {
        const start = get(
          this.contentInfo,
          ['liveepgschannellist', 'list', '0', 'starttime'],
          '',
        )
        const end = get(
          this.contentInfo,
          ['liveepgschannellist', 'list', '0', 'endtime'],
          '',
        )
        return '' + start.split(' ').pop() + ' ~ ' + end.split(' ').pop()
      },
      zzim() {
        return get(this.contentInfo, 'zzim', 'n').toLowerCase()
      },
      contentId() {
        return get(this.contentInfo, 'channelid', '')
      },
    },
    created() {
      this.updateVodButton()
    },
    methods: {
      moveToVod() {
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: {
            section: 'vod',
          },
          query: {
            programid: this.contentInfo.programid,
          },
        })
      },
      updateVodButton() {
        const programID = get(this.contentInfo, 'programid', '')
        if (programID === '') {
          this.isVisibleVodButton = false
        } else {
          LiveInfoService.getContentIdByProgramId({ programID }, () => {
            this.isVisibleVodButton = false
          }).then(({ data }) => {
            const contentId = get(data, 'contentid', '')
            if (contentId !== '') {
              this.isVisibleVodButton = true
            } else {
              this.isVisibleVodButton = false
            }
          })
        }
      },
    },
  }
</script>
<style scoped>
  .next-lineup {
    margin: 0 -10px;
    padding: 20px 10px;
    border-top: 1px solid #2f2f2f;
    border-bottom: 1px solid #2f2f2f;
    font-size: 0;
  }
  .btn-box + .next-lineup {
    margin-top: 20px;
  }
  .next-lineup > div {
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
  }
  .next-lineup .next {
    width: 85px;
    color: #a5a5a5;
  }
  .next-lineup .program-metadata {
    width: calc(100% - 109px);
    padding-right: 20px;
  }
  .next-lineup .program-metadata > span {
    display: block;
  }
  .next-lineup .program-title {
    overflow: hidden;
    color: #a5a5a5;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .next-lineup .program-play-time {
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
    color: #a5a5a5;
  }
  .next-lineup .program-alarm {
    width: 24px;
    height: 24px;
  }
</style>
